import { observable, action, computed } from 'mobx';
import ContainerStore from './container';

// Cart Store
export default class CartStore extends ContainerStore {
  @observable preview = null;
  @observable items = new Map();
  @observable activePositionCount = null;
  @observable activeLabel = null;

  @computed get isActiveEmpty() {
    return this.activePositionCount === null ? null : !this.activePositionCount;
  }

  @computed get hasActivePositions() {
    return this.activePositionCount === null ? null : !!this.activePositionCount;
  }

  update(data) {
    // Reload checkout if checkout is active
    // because of cart in checkout
    if ($('[data-bind-html="checkout:html"]').length > 0) {
      $.stores.checkout.load();
    }

    this.preview = data.preview || null;
    if (data.container && data.container.container_type === 'cart') {
      this.activePositionCount = data.container ? data.container.position_count : null;
      this.activeLabel = data.container.label;
    }

    if (data.container) {
      const htmlEl = $('[data-bind-html="cart:html"]');
      const dataContainerId = htmlEl.attr('data-container-id');
      if (htmlEl.length === 0 || !dataContainerId || parseInt(dataContainerId, 10) === data.container.id) {
        super.update(data);
      }
    } else {
      super.update(data);
    }
  }

  @action
  post(url, formdata) {
    return super.post(url, formdata).then((result) => {
      if (result.position && this.items.has(result.position.item_id)) {
        this.items.get(result.position.item_id).set('quantity', parseFloat(result.position.quantity));
        this.items.get(result.position.item_id).set('deleteUrl', result.position.delete_url);
        this.items.get(result.position.item_id).set('positionCount', result.position.position_count);
      } else if (result.item_id && this.items.has(result.item_id)) {
        this.items.get(result.item_id).set('quantity', '');
        this.items.get(result.item_id).set('deleteUrl', '');
        this.items.get(result.item_id).set('positionCount', '');
      }
      if (result.group_select) {
        $(result.group_select).foundation().foundation('open');
      }
      return result;
    });
  }

  @action
  clear(url, formdata) {
    return super.post(url, formdata).then(() => {
      this.items = new Map();
    });
  }

  @action
  loadPreview(url) {
    return $.ajax({
      url,
      method: 'GET',
    }).then((html) => {
      this.preview = html;
      return html;
    });
  }

  @action
  create(url, formdata) {
    formdata.push({ name: 'render', value: 1 });
    formdata.push({ name: 'calculate', value: 1 });
    return super.post(url, formdata);
  }

  @action
  activate(url, formdata) {
    formdata.push({ name: 'render', value: 1 });
    formdata.push({ name: 'calculate', value: 1 });
    return super.post(url, formdata);
  }

  gatherCartItems($wrapper) {
    $wrapper.find('[data-cart-item]').each((i, elem) => {
      const itemId = elem.getAttribute('data-cart-item');
      let quantity = elem.getAttribute('data-cart-item-quantity');
      quantity = quantity !== '' ? parseFloat(quantity) : '';
      const deleteUrl = elem.getAttribute('data-cart-item-delete-url');
      const positionCount = elem.getAttribute('data-cart-item-position-count');

      if (!this.items.has(itemId)) {
        this.items.set(itemId, new Map([
          ['quantity', quantity],
          ['deleteUrl', deleteUrl],
          ['positionCount', positionCount],
          ['inCart', computed(() => this.items.get(itemId).get('quantity') > 0)],
        ]));
      }
    });
  }

  @computed get cartLabel() {
    return this.label ? `"${this.label}"` : '';
  }

  @computed get activeCartLabel() {
    return this.activeLabel ? `"${this.activeLabel}"` : '';
  }
}
